interface ICascadeReadinessChannel {
    cascadeEnabled?: boolean;
    priority?: unknown;
    [key: string]: unknown;
}

export function hasReadyMarketingChannel(
    channels: ICascadeReadinessChannel[],
    isAuthorized: (channel: ICascadeReadinessChannel) => boolean,
): boolean {
    if (!Array.isArray(channels) || typeof isAuthorized !== "function") {
        return false;
    }

    return channels.some((channel) => {
        const priority = channel?.priority;
        return (
            channel?.cascadeEnabled === true &&
            typeof priority === "number" &&
            Number.isFinite(priority) &&
            priority > 0 &&
            isAuthorized(channel) === true
        );
    });
}
